import { useEffect } from 'react'
import { workspaceViewEvent } from 'tag-manager/workspace_view'
import { App, getServerSideProps } from 'workspace'

function Workspace(props) {
  useEffect(() => {
    workspaceViewEvent()
  }, [])

  return <App {...props} />
}

export { getServerSideProps }
export default Workspace
